import { lazy } from 'react';

/**
 * Componenti plugin a livello di shell che non sono pagine instradabili e
 * quindi non esprimibili nel manifest `ui.routes` (widget globali, banner,
 * alert). Centralizzati qui: app.tsx mantiene zero import diretti dai
 * package plugin.
 */
export const IncomingReservationAlert = lazy(
  () => import('@striker/plugin-restaurant/ui/incoming-reservation-alert'),
);
